import { useContext } from 'react';
import Context from './Context';

export default function useOrgApi() {
  const { org } = useContext(Context);
  return org;
}
